<template>
  <div >
    <div class="tags" v-if="ind=='1'">
      <div class="right-top" data-aos="fade-up">
        <div class="one">
          <div class="fs-2 w-700 lyd-title-colo1">智能报账</div>
          <div class="bar"></div>
          <div class="cont">
            <div class="flex-one">
              <p >
                智能合同管理平台以项目、合同为源头的全生命周期的智能合同管理，包含合同评审、合同签订、合同变更、合同结算、合同发票、合同收付款管理，支持不同行业的采购合同、销售合同、物资合同、分包合同、设备合同及其他合同管理。支持建筑行业的建造成本管理、建安收支管理等。也支持线上电子签合同管理。
              </p>
              <img class="flex-one-img1" src="@/assets/images/portfolio/dialog/eec/智能报账.png" alt="" />
            </div>
            <h5 class="padHeight">商旅与费控一体化管理：</h5>
            <img class="imgmian1 margin0auto"  src="@/assets/images/portfolio/dialog/eec/智能报账2.png" alt="" />
            <div class="flex-one">
              <p class="padHeight">在聚合企业商旅->智能报账->企业付款->企业核算的全流程各环节支持丰富的事前、事中、事后的管控模式和智能化、自动化技术，赋能业务提效与创新。</p>
              <img class="flex-one-img1" src="@/assets/images/portfolio/dialog/eec/智能报账3copy.png" alt="" />
            </div>
            <h5 class="padHeight">对公业务的企业支出一体化管理：</h5>
            <ul class="padHeight">
              <li>与供应链、项目管理、人力管理、资产管理等一体化的企业支出管理，可真正实现财务业务一体化处理，提高业务处理效率，杜绝人为错误发生。</li>
              <li>保证业务发生的合规合法性，基于财务业务一体化，保证数出同源，经过有效审批，为后续实际付款提供有效查询和支持。</li>
              <li>可实现每笔采购应付业务的可分析、可追溯。</li>
              <li>可通过EECloud进行采购应付和付款业务的核销处理，并为后续的财务分析提供更细颗粒度的数据支持。</li>
              <li>实现资产一体化管理。</li>
            </ul>
            <h5 class="padHeight">业务收入一体化管理：</h5>
            <div>
              <p>EECloud业务收入一体化管理包括销售业财即销售管理系统与应收收入确认的一体化管理以及收款认领管理。</p>
              <ul class="padHeight">
                <li>根据客户业务情况，控制应收账款的限额和收回的时间，以确保企业营运资金的循环周转。</li>
                <li>规范应收、收款管理，规避业务人员进行回款调整、违规发货，避免应收账款管理失控风险。</li>
                <li>充分估计应收账款的持有成本和风险。</li>
                <li>及时组织安排到期和逾期的应收账款的催收，避免企业资金被占用。</li>
                <li>精准分析客户画像与利润贡献。</li>
              </ul>
            </div>
          </div>
          <div class="conts mt3 conts-alinetimecenter">
            <div class="contentBox width55">
              <p>通过合同、客户相关业务处理，实现应收款项核销、自动进行往来对账、结算管理，提供应收款项回款分析、账龄分析、周转分析、往来对账等功能，并能根据不同设置提供债权、催款提示等。</p>
              <p>通过收款认领平台，基于银行下载流转/手工导入流水，人工/系统自动认收款流水生成收款单据，收款单审核通过自动结算入账处理。实现收款单、电子回单、凭证三单匹配。</p>
            </div>
            <img class="imgeec1-1" src="@/assets/images/portfolio/dialog/eec/智能报账4.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="tags" v-if="ind=='2'">
      <div class="right-top" data-aos="fade-up">
        <div class="one">
          <div class="fs-2 w-700 lyd-title-colo1">发票管理</div>
          <div class="bar"></div>
          <div class="conts mt3">
            <p class="width55">EECloud发票管理与智能报账、影像系统、税务管理一体化应用，实现进项发票的归集、自动查验、自动查重、解析、存管、报销入账等全流程过程管理。</p>
            <img class='imgeec1-2' src="@/assets/images/portfolio/dialog/eec/发票管理1.png" alt="" />
          </div>
		  <div class="conts mt3">
		    <p class="width55">产品支持发票夹采集发票功能，票小记发票夹提供APP和微信小程序两种使用途径，支持拍照采集、上传图片、扫描二维码、微信卡包引入、文件导入、手工采集等6种方式采集发票信息，且支持对增值税发票进行查验，票据自动转存影像文件，用于报销审核及电子档案存储。对已采集的发票可进行转让，适用于多种业务报账场景。</p>
		    <img class='imgeec1-3' src="@/assets/images/portfolio/dialog/eec/发票管理2.png" alt="" />
		  </div>
        </div>
      </div>
    </div>
    <div class="tags" v-if="ind=='3'">
      <div class="right-top" data-aos="fade-up">
        <div class="one">
          <div class="fs-2 w-700 lyd-title-colo1">电子影像与电子档案管理</div>
          <div class="bar"></div>
          <div class="cont">
            <p>EECloud影像管理是通过手机APP、扫描仪、高拍仪等进行发票、纸质单据的扫描以及OCR光学识别，实现业务系统运营集中化、纸质单据影像化、业务流程处理便捷化。</p>
            <p>建立企业级影像管理平台，将合同、对账单、发票等都扫描管理，通过发票号、合同号、对账单号等任何一个信息都可以查询到相关的档案。通过此功能，一次查询就可以实现将整个业务链产生的所有档案全部进行显示调阅，实现业务可追溯，提升企业运营效率。</p>
            <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/电子影像1.png" alt="" />
            <p>构建电子档案统一管理体系，实现文件资料的分类、归档、上传、下载、检索、管理等全业务电子化、自动化归档并拥有可靠的安全性，对所有的电子档案资料进行生命周期管理。</p>
            <p>通过会计档案的无纸化管理，减少企业打印成本、IT耗材、存管人力和空间成本等，节能减排，绿色环保，减少生产办公成本。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="tags" v-if="ind=='4'">
      <div class="right-top" data-aos="fade-up">
        <div class="one">
          <div class="fs-2 w-700 lyd-title-colo1">一键报税</div>
          <div class="bar"></div>
          <div class="cont">
            <p>EECloud增值税管理系统为企业提供了税务业务处理方案，通过发票夹多种采集方式进行发票采集，与报账系统关联引用发票信息便捷填单，系统按照税法要求自动进行价税分离，满足增值税核算要求。并与核算系统对接，实时传递发票对应账务信息，且与税局对接，实现一键认证。</p>
            <p>EECloud增值税管理系统，实现从业务到财务再到税务核算、纳税申报的顺畅操作。通过系统层级的“业财税一体化”，为增值税核对“票、账、表”信息提供了依据。EECloud增值税严密的管理不仅帮助企业保证缴税的合规性、合法性，更起到了降低税负风险的作用。</p>
            <p>增值税系统出具进项发票台账、抵扣统计表以及其他扣税明细表等统计报表且关联单据以及财务入账凭证，便于税务人员进行查询统计。</p>
            <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/一键报税.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="tags" v-if="ind=='5'">
      <div class="right-top" data-aos="fade-up">
        <div class="one">
          <div class="fs-2 w-700 lyd-title-colo1">资金结算</div>
          <div class="bar"></div>
          <div class="cont">
            <p>
              EECloud统一资金结算平台，实现资金业务处理信息化、自动化、不落地处理，提升结算效率、加速资金流转、提升整体效益，通过加强内部资金统一调配，加速内部资金周转、降低资金沉淀量、提高整体资金使用效益。通过银企直联、RPA网银机器人完成资金的统一支付，并通过头寸管理结合资金计划严控资金头寸，保障资金安全。
            </p>
            <p>同时实现资金的逆向流程线上管理，实现对于错付退回、银行账户有误逆向流程的线上审批，避免出现重付、多付、账务核算错误、账户错误无人监控的情况。</p>
            <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/资金结算.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="tags" v-if="ind=='6'">
      <div class="right-top" data-aos="fade-up">
        <div class="one">
          <div class="fs-2 w-700 lyd-title-colo1">连接器</div>
          <div class="bar"></div>
		  <div class="conts mt3">
		    <p class="width55">EECloud的Business Connector（连接器模块），通过连接器将其他业务系统等无缝与EECloud整合。通过统一数据连接器充分结合，让连接+报账实现业财的全面融合。</p>
		    <img class='imgeec1-3' src="@/assets/images/portfolio/dialog/eec/连接器.png" alt="" />
		  </div>
        </div>
      </div>
    </div>
    <div class="tags" v-if="ind=='7'">
      <div class="right-top" data-aos="fade-up">
        <div class="one">
          <div class="fs-2 w-700 lyd-title-colo1">会计引擎</div>
          <div class="bar"></div>
          <div class="conts mt3">
            <div class="contentBox width55">
              <p>当企业已经有核算系统时，通过EECloud会计引擎，智能化、自动化生成财务核算系统凭证，实现智能记账。</p>
              <p>EECLoud会计引擎可定义、可配置不同行业和企业性质的凭证生成模板，只需会计知识即可。同时，可与用友、金蝶、浪潮、SAP、ORACLE等不同的产品系列集成实践经验，EECLoud通过会计引擎都能迅速地、自动化生成会计凭证。</p>
            </div>
            <img  class='imgeec1-3' src="@/assets/images/portfolio/dialog/eec/会计引擎.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="tags" v-if="ind=='8'">
      <div class="right-top" data-aos="fade-up">
        <div class="one">
          <div class="fs-2 w-700 lyd-title-colo1">移动应用</div>
          <div class="bar"></div>
          <div class="conts mt3">
            <div class="contentBox width55">
              <div>移动报销：将费用报销与费用申请、事务申请、金额管控、发票管控等集成，并结合预算管控、成本中心管控要求，实现费用归集，并通过报表展示费用的发生情况。</div>
              <div class="mgtop10">移动审批：用户随时随地通过APP、钉钉、企业微信、飞书、企业OA等多种社交软件使用审批功能，对要素事项进行提醒，感受审批便捷。</div>
            </div>
            <img class='imgeec1-3' src="@/assets/images/portfolio/dialog/eec/移动应用.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.tags {
	h5{
		font-size: 16px !important;
	}
  img {
    text-align: center;
	height:auto !important
  }
  .padHeight {
    margin: 3rem 0;
  }
  .flex-one{
    display: flex;
    align-items: center;
	justify-content: space-between;
    // width: 90%;
	p{
		width: 55%;
		flex-shrink:0;
		font-size: 1.75rem !important
	}
	.flex-one-img1{
		width:50rem !important
	}
	.flex-one-img2{
		width:70rem !important
	}
  }
}
.tags {
  .right-top {
    .one {
      .cont {
        margin: 3rem 0;
        // height: calc(100vh - 220px);
        display: block !important;
        .contentBox{
          width: 80rem;
          margin-right: 5rem;
        }
        img{
          width: 22rem;
          height: 11rem;
        }
      }
    }
  
    .two {
      .cont2 {
        .tags {
          display: flex;
  
          .tag {
            opacity: 0.988;
            //width: 130px;
            padding: 10px 20px;
            margin: 0 5px;
            height: 45px;
            border: 1px solid #99a5bb;
            border-radius: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
<script>
export default {
  name: "tags",
  props:{
    ind:''
  },
  data() {
    return {}
  },
  mounted(){
    console.log(this.ind);
  },
}
</script>

